import axios from 'axios';

export default class HttpUtil {
	static buildHeaders() {
		let headers = {};
		headers['Content-Type'] = 'application/json';
		headers['Authorization'] = `bearer ${localStorage.getItem('AccessToken')}`;

		return headers;
	}

	static eco_POST = (url, data) => axios.post(url, data, { headers: HttpUtil.buildHeaders() });

	static eco_POST_CONFIG = (url, data, config) =>
		axios.post(url, data, { ...config, headers: HttpUtil.buildHeaders() });

	static eco_PUT_CONFIG = (url, data, config) =>
		axios.post(url, data, { ...config, headers: HttpUtil.buildHeaders() });

	static eco_GET = url => axios.get(url, { headers: HttpUtil.buildHeaders() });

	static eco_PUT = (url, data) => axios.put(url, data, { headers: HttpUtil.buildHeaders() });
}
